import { Palette } from '@/themes/themeOverrides/Palette';

export const useBarIndicatorsColors = (value, breakpoints, reverse = false, reversColors = false) => {
    let activeColor;
    let activeBars = 0;

    if (reversColors) {
        if (value <= 25) {
            activeBars = 1;
        } else if (value <= 50) {
            activeBars = 2;
        } else if (value <= 75) {
            activeBars = 3;
        } else {
            activeBars = 4;
        }

        if (value <= 60) {
            activeColor = Palette.green.green600;
        } else if (value <= 80 && value > 60) {
            activeColor = Palette.yellow.yellow900;
        } else if (value > 80) {
            activeColor = Palette.red.red800;
        }
    } else {
        if (value <= breakpoints[0]) {
            activeColor = Palette.red.red800;
            activeBars = 1;
        } else if (value <= breakpoints[1]) {
            activeColor = Palette.yellow.yellow800;
            activeBars = 2;
        } else if (value <= breakpoints[2]) {
            activeColor = Palette.green.green600;
            activeBars = 3;
        } else {
            activeColor = Palette.green.green600;
            activeBars = 4;
        }
    }

    const colors = Array.from({ length: 4 }, (_, i) => (i < activeBars ? activeColor : Palette.gray.gray400));
    return reverse ? colors.reverse() : colors;
};
